import Vue from "vue";
import AvatarMixin from '@/mixins/Avatar';
import FilenameMixin from '@/mixins/Filename';
import sound from '@/assets/sounds/ping.mp4';

const getDefaultState = () => {
	return {
		comments: [],
		replyTo: null,
		mentionedAssets: [],
		currentChannel: null,
		previousChannel: null,
		whoIsTyping: null,
		uploadingAsset: false,
	};
};

const Comments = {
	namespaced: true,
	state: getDefaultState(),
	mutations: {
		RESET_STATE: state => {
			Object.assign(state, getDefaultState());
		},

		SET_COMMENTS: (state, payload) => {
			state.comments = payload;
		},

		SET_REPLY_TO: (state, payload) => {
			state.replyTo = payload;
		},

		//
		// DELETE: (state, payload) => {
		//
		// }

		SET_MENTIONED_ASSETS: (state, payload) => {
			state.mentionedAssets = payload;
		},

		SET_CURRENT_CHANNEL: (state, payload) => {
			state.previousChannel = state.currentChannel;
			state.currentChannel = payload;
		},

		PUSH_COMMENT: (state, payload) => {
			state.comments.push(payload);
		},

		SET_WHO_IS_TYPING: (state, payload) => {
			state.whoIsTyping = payload;
		},

		UPDATE_COMMENT: (state, payload) => {
			Vue.set(state.comments, state.comments.findIndex(comment => comment.id == payload.id), payload);
			state.comments.forEach((comment, index) => {
				if (comment.parentMessage?.id == payload.id) {
					let data = {...state.comments[index]};
					data.parentMessage = payload;
					Vue.set(state.comments, index, data);
				}
			})
		},

		SET_UPLOADING_ASSET: (state, payload) => {
			state.uploadingAsset = payload;
		}
	},
	actions: {
		resetState: ({ commit }) => {
			commit("RESET_STATE");
		},

		push: ({ commit, dispatch }, payload) => {
			commit("PUSH_COMMENT", payload);
			dispatch("notifyForNewComment");
			dispatch('goToBottom');
		},

		notifyForNewComment: ({ dispatch }) => {
			if (!document.hidden && lutify.activePreviewsSidebarContainer == 'comments') return;
			(new Audio(sound)).play();
		},

		goToBottom: () => {
			Vue.prototype.$nextTick(() => {
				if (lutify.activePreviewsSidebarContainer == 'comments') {
					$('#comments-container').animate({ scrollTop: $('#comments-container').prop("scrollHeight") + 12 }, 500);
					lutify.markNewCommentNotificationsAsRead();
				}
			})
		},

		switch: async ({ dispatch, rootState }, channelName) => {
			let currentChannel = channelName || 'media';

			await dispatch('setCurrentChannel', currentChannel);
			await dispatch('fetch');
		},

		fetch: ({ commit, state, rootState, dispatch, rootGetters }, payload = {}) => {
			if (rootState.User.account.plan_id == 1) return;

			let params = {};

			if (!payload.folder_id) {
				if (rootGetters['User/isGuest']) params.folder_id = rootState.Projects.currentFile.folder_id;
				else params.folder_id = rootGetters['Projects/folderBySlug'](state.currentChannel)?.id;
			}

			if (!payload.file_id) {
				if (rootGetters['User/isGuest']) params.file_id = rootState.Projects.currentFile.parent_file_id;
				else params.file_id = rootState.Projects.image;
			}

			return Vue.prototype.$apiService
				.get(`accounts/${rootState.User.account.id}/projects/${rootState.Projects.project.id}/messages`, {
					params
				})
				.then(response => {
					commit('SET_COMMENTS', response.data.data);
					dispatch('goToBottom');
				})
				.catch(err => console.log(err.response));
		},

		create: ({ commit, state, rootState, rootGetters }, payload) => {
			if (!payload.folder_id) {
				if (rootGetters['User/isGuest']) payload.folder_id = rootState.Projects.currentFile.folder_id;
				else payload.folder_id = rootGetters['Projects/folderBySlug'](state.currentChannel)?.id;
			}

			if (!payload.file_id) {
				if (rootGetters['User/isGuest']) payload.file_id = rootState.Projects.currentFile.parent_file_id;
				else payload.file_id = rootState.Projects.image;
			}

			let formdata = new FormData();
			formdata.append("folder_id", payload.folder_id);
			formdata.append('file_id', payload.file_id);
			formdata.append("text", payload.text);
			if (payload.message_id) formdata.append("message_id", payload.message_id);
			payload.mentions.forEach((mention, key) => {
				formdata.append(`mentions[${key}][type]`, mention.type);
				formdata.append(`mentions[${key}][id]`, mention.id);
				formdata.append(`mentions[${key}][text]`, mention.text);
			})

			return Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/projects/${rootState.Projects.project.id}/messages`, formdata)
				.then(response => {})
				.catch(err => console.log(err.response));

		},

		delete: ({ commit, rootState }, payload) => {
			// commit("DELETE", payload);
			return Vue.prototype.$apiService
				.delete(`accounts/${rootState.User.account.id}/projects/${rootState.Projects.project.id}/messages/${payload}`)
				.then(response => {})
				.catch(err => console.log(err.response));
		},

		update: ({ commit }, payload) => {
			commit('UPDATE_COMMENT', payload);
		},

		markAsSeen: ({ commit, rootState }, payload) => {
			return Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/projects/${rootState.Projects.project.id}/markAsSeen`, {
					message_id: payload,
				})
				.then(response => {

				})
				.catch(err => console.log(err.response));
		},

		replyTo: ({ commit }, payload) => {
			commit("SET_REPLY_TO", payload);
		},

		setMentionedAssets: ({ commit, rootState }, payload) => {
			payload.forEach(mention => {
				let thumbnail = rootState.Projects.fileThumbnailObjects[mention.id];
				mention.thumbnail = thumbnail || '';
			})

			commit("SET_MENTIONED_ASSETS", payload);
		},

		setCurrentChannel: ({ commit }, payload) => {
			commit('SET_CURRENT_CHANNEL', payload);
		},

		setWhoIsTyping: ({ commit, state }, payload) => {
			payload.timestamp = Date.now();
			commit("SET_WHO_IS_TYPING", payload);
			setTimeout(() => {
				if (Date.now() - state.whoIsTyping.timestamp > 4000) {
					commit("SET_WHO_IS_TYPING", null);
				}
			}, 5000)
		},

		uploadingAssetLoader: ({ commit }, payload) => {
			commit("SET_UPLOADING_ASSET", payload);
		}
	},
	getters: {
		atValues: (state, getters, rootState, rootGetters) => {
			let data = [];
			rootState.Projects.project.users.forEach(user => {
				let account = rootGetters["Organizations/memberAccountByUserId"](user.id);
				if (!account) return;

				data.push({
					id: account.pivot.id,
					user_id: user.id,
					value: user.name,
					type: 'account',
					img: AvatarMixin.methods.getGravatar(user.email),
				})
			});

			return data;
		},

		findAtValue: (state, getters) => account_id => {
			return getters.atValues.find(user => user.id == account_id);
		},

		hashValues: (state, getters, rootState, rootGetters) => type => {
			let data = [];
			let filesList = [
				...rootGetters['Projects/allAssets'](),
				...rootState.Projects.commentUploadList
			];

			filesList.forEach(file => {
				if (type && type !== file.type) return;
				data.push({
					id: file.id,
					value: file.type == 'image' ? FilenameMixin.methods.stripTimestamp(file.name) : FilenameMixin.methods.stripTimestampAndExtension(file.name),
					type: 'file',
					fileType: file.type,
					commentUpload: rootGetters["Projects/fileHasTag"](file, 'comment_upload', 1) ? true : false,
					img: rootState.Projects.fileThumbnailObjects[file.id],
					file
				})
			});

			return data;
		},

		assetMentionsFromDelta: () => delta => {
			let mentions = [];
			delta.ops.forEach(item => {
				if (!item.insert?.mention?.denotationChar) return;
				if (['#', '$', '%'].includes(item.insert.mention.denotationChar)) mentions.push(item.insert.mention);
			});

			return mentions;
		},
	},
};

export default Comments;
